'use client';

import { Typography } from '@/components';
import { DialogFooter } from '@/components/dialog';
import { Button } from '@/components';
import { t } from 'i18next';

interface InterestModalStepperProps {
  onNext: () => void;
  onBack: () => void;
  validationError?: string;
  isLastStep: boolean;
  isThankYouStep: boolean;
  showBackButton: boolean;
  validateCurrentStep: () => boolean;
  disabled?: boolean;
}

export function InterestModalStepper({
  onNext,
  onBack,
  validationError,
  isLastStep,
  isThankYouStep,
  showBackButton,
  validateCurrentStep,
  disabled = false,
}: InterestModalStepperProps) {
  const handleNext = () => {
    if (!validateCurrentStep()) {
      return;
    }
    onNext();
  };

  const getButtonText = () => {
    if (isThankYouStep) return 'Finish';
    if (isLastStep) return 'Submit';
    return 'Next';
  };

  return (
    <>
      {validationError && (
        <div className="flex items-center justify-center">
          <Typography
            as="p"
            size="body-3"
            color="secondary"
            weight="normal"
            className="text-sm font-semibold text-red-600 md:text-base"
          >
            {validationError}
          </Typography>
        </div>
      )}

      <DialogFooter className="flex items-center justify-between gap-3 pt-3">
        {showBackButton && (
          <Button
            onClick={onBack}
            disabled={disabled}
            color="ghostPrimary"
            className="rounded-full px-6 py-2 font-semibold transition-all duration-200 hover:scale-105 hover:shadow-md active:scale-95 md:text-base"
          >
            {t('Back')}
          </Button>
        )}
        <Button
          onClick={handleNext}
          disabled={disabled}
          color="primary"
          className="ml-auto rounded-full px-8 py-2 text-white transition-all duration-200 hover:scale-105 hover:shadow-xl active:scale-95 md:text-base"
        >
          {getButtonText()}
        </Button>
      </DialogFooter>
    </>
  );
}
